export default __webpack_public_path__ + "static/media/elaichi-tea.04228704.jpg";